/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DigitableLineResponseViewModel } from "../types/DigitableLineResponseViewModel.ts";

export const digitableLineResponseViewModelSchema = z.object({
  digitableLines: z.array(z.string()).nullish(),
  count: z.optional(z.number().int()),
}) as unknown as ToZod<DigitableLineResponseViewModel>;
